module.exports = __webpack_public_path__ + "assets/img/ic-notlogin-day.97bc8fb2.svg";